module.exports = __webpack_public_path__ + "static/media/axisbyte_logo.0ba1bde2.png";